// The function reads appDefinitions from the div on the page as well as preinstalled apps
import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { fetchIdentity } from '@office-start/identity-service';
import { fetchAppDefinitionsFromAppsService, fetchAppDefinitionsFromPage, fetchPreinstalledApps, } from './api';
import { getSideloadedApps } from './M365AppsLocalSideloadService';
import { m365AppDefinitionsBehaviorSubject } from './state';
export var loadAppDefinitions = function (fromPageDiv) { return __awaiter(void 0, void 0, void 0, function () {
    var officeIdentity, definitionFromAppService, _a, updatedAppDefinitions, _b, shouldNotUpdate;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, fetchIdentity()];
            case 1:
                officeIdentity = _c.sent();
                if (!fromPageDiv) return [3 /*break*/, 3];
                return [4 /*yield*/, fetchAppDefinitionsFromPage()];
            case 2:
                _a = _c.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, fetchAppDefinitionsFromAppsService()];
            case 4:
                _a = _c.sent();
                _c.label = 5;
            case 5:
                definitionFromAppService = _a;
                _b = [[]];
                return [4 /*yield*/, fetchPreinstalledApps()];
            case 6:
                updatedAppDefinitions = __spreadArray.apply(void 0, [__spreadArray.apply(void 0, [__spreadArray.apply(void 0, _b.concat([__read.apply(void 0, [(_c.sent())]), false])), __read(definitionFromAppService), false]), __read(getSideloadedApps(officeIdentity.puid || '')), false]);
                shouldNotUpdate = m365AppDefinitionsBehaviorSubject.getValue().length > 0 &&
                    definitionFromAppService.length === 0;
                !shouldNotUpdate &&
                    m365AppDefinitionsBehaviorSubject.next(updatedAppDefinitions);
                return [2 /*return*/];
        }
    });
}); };
export var reloadAppDefinitions = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, loadAppDefinitions(false)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
//# sourceMappingURL=loadAppDefinitions.js.map